export default {"src":"/_next/static/media/AccountIcon.b5cd9ceb.svg","height":16,"width":13};